var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar'),_c('div',{staticClass:"relative md:ml-64"},[_c('admin-navbar'),_c('header-stats'),_c('div',{staticClass:"px-4 md:px-10 mx-auto h-full w-full -m-24"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }